import axios from 'axios';

//const baseURL = "/api";
//const baseURL = "//localhost:3001/api";
const baseURL = "https://www.clubfamailla.com.ar/api";
//const baseURL = "https://017jhlsg-4000.brs.devtunnels.ms/";
const apiConnect = axios.create({
    baseURL,
    timeout: 120000,
    
});

export default apiConnect;